import { apiRequest } from ".";

export const getCategoriesAPI = (data) => {
  return apiRequest({
    method: "get",
    url: `categories`,
    queryParams: data,
  });
};
export const getSubCategoriesAPI = (data) => {
  return apiRequest({
    method: "get",
    url: `categories`,
    queryParams: data,
  });
};
export const addCategoryAPI = (data) => {
  return apiRequest({
    method: "post",
    url: `categories`,
    data: data,
  });
};
export const editCategoryAPI = (id, data) => {
  return apiRequest({
    method: "put",
    url: `categories/${id}`,
    data: data,
  });
};
export const deleteCategoryAPI = (id) => {
  return apiRequest({
    method: "delete",
    url: `categories/${id}`,
    data: {},
  });
};
